import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';
import {
  NetworkDisconnectionContainer,
  NetworkDisconnectionRetryContainer,
  NetworkDisconnectionBody
} from './NetworkDisconnectionComponent.style';

// eslint-disable-next-line no-underscore-dangle
function _NetworkDisconnectionComponent(props) {
  const { canRetry, retryConnection } = props;
  const message = canRetry
    ? i18n('Could not connect to Yesplan.')
    : i18n('Could not connect to the internet.');

  return (
    <NetworkDisconnectionContainer
      $withBackground={canRetry}
      data-test-type="errorMessage"
    >
      <NetworkDisconnectionBody as="div">
        {message}
        {canRetry && (
          <NetworkDisconnectionRetryContainer>
            <Button
              onClick={retryConnection}
              color="primary"
              variant="outlined"
              size="medium"
            >
              {i18n('Retry')}
            </Button>
          </NetworkDisconnectionRetryContainer>
        )}
      </NetworkDisconnectionBody>
    </NetworkDisconnectionContainer>
  );
}

_NetworkDisconnectionComponent.propTypes = {
  canRetry: PropTypes.bool.isRequired,
  retryConnection: PropTypes.func.isRequired
};

export default _NetworkDisconnectionComponent;
